import React from 'react';

const List = ({ items, renderItem }) => {
    return (
        <ul className="divide-y divide-gray-200">
            {items.map((item, index) => renderItem(item, index))}
        </ul>
    );
};

export default List;
